define('SEOImprovements.PDP.View', [
	'jQuery',
	'ProductDetails.Full.View',
	'ProductDetails.ImageGallery.View',
	'SC.Configuration',
	'underscore'
], function SEOImprovementsPDPView(
	jQuery,
	ProductDetailsFullView,
	ProductDetailsImageGalleryView,
	Configuration,
	_
) {
	'use strict';

	_.extend(ProductDetailsImageGalleryView.prototype, {
		getContext: _.wrap(ProductDetailsImageGalleryView.prototype.getContext, function getContext(fn) {
			var originalRet = fn.apply(this, _.toArray(arguments).slice(1));
			var self = this;
			_.each(originalRet.images, function eachImg(image) {
				if (!image.altimagetext) {
					image.altimagetext = self.model.getItem().get('keyMapping_name') || self.model.getItem().get('displayname')
					|| self.model.getItem().get('storedisplayname2') || self.model.getItem().get('_name');
				}
			});
			return originalRet;
		})
	});

	_.extend(ProductDetailsFullView.prototype, {
		getMetaDescription: _.wrap(ProductDetailsFullView.prototype.getMetaDescription, function getMetaDescription(fn) {
			var ret = fn.apply(this, _.toArray(arguments).slice(1));
			var descriptionFieldId;
			var descriptionField;
			var div;
			var descriptionText;
			var item;
			if (!ret) {
				descriptionFieldId = Configuration.get('seo.productDescriptionField');
				item = this.model.get('item');
				// eslint-disable-next-line
                descriptionField = descriptionFieldId && item.get(descriptionFieldId) ? item.get(descriptionFieldId)
					: item.get('storedetaileddescription') || item.get('storedescription') || item.get('storedescription2') || item.get('featureddescription');

				// To remove html tags
				div = document.createElement('div');
				div.innerHTML = descriptionField;
				descriptionText = div.innerText;

				return descriptionText;
			}
			return ret;
		}),
		getTitle: _.wrap(ProductDetailsFullView.prototype.getTitle, function getTitle(fn) {
			var ret = fn.apply(this, _.toArray(arguments).slice(1));
			return (ret || this.model) && this.model.get('item') && this.model.get('item').get('_pageTitle');
		})
	});
});
